"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLazyPropType;

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

function createLazyPropType(rawPropType) {
  var propTypeWithFuncEval = function propTypeWithFuncEval(props, propName) {
    var value = props[propName];

    if (!value || typeof value === 'function') {
      return null;
    } // If the value is not a function, check that it satisfies rawPropType


    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    return rawPropType.apply(void 0, [props, propName].concat(rest));
  }; // Name this propType "lazyX", where "X" is the name of the raw prop type


  var rawPropTypeName = rawPropType.__INTROSPECTION__ ? rawPropType.__INTROSPECTION__.type : 'value';
  var lazyPropTypeName = "lazy" + (rawPropTypeName.charAt(0).toUpperCase() + rawPropTypeName.slice(1));
  var chainablePropType = (0, _createChainablePropType.default)(propTypeWithFuncEval, lazyPropTypeName);
  return chainablePropType;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/propTypes/createLazyPropType.js
// module id = 75
// module chunks = 209 210 211 212